
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","data-token-name":"view-check-circle"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.74 6.24c.167-.167.327-.333.473-.5a1.1 1.1 0 000-1.48C13.467 2.333 10.667.453 8 .5 5.333.547 2.533 2.333.787 4.26a1.1 1.1 0 000 1.48A12.8 12.8 0 005.133 8.9","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.88 7.24A2.5 2.5 0 1110.5 5c-.002.225-.033.45-.093.667M11.5 15.5a4 4 0 100-8 4 4 0 000 8z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.28 10.34l-1.947 2.58a.5.5 0 01-.753.053L9.593 12","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    